import { OperatorFunction } from "rxjs";
import { filter, map, withLatestFrom, distinctUntilChanged } from "rxjs/operators";

import { ApiStateStoreState } from "../api-state-store.service";
import { Organization } from "../resources/organization/organization";
import { OrganizationService } from "../resources/organization/organization.service";
import { organizationId } from "./organization-id";

export function currentOrganization(): OperatorFunction<ApiStateStoreState, Organization> {
  return storeState =>
    storeState.pipe(
      withLatestFrom(storeState.pipe(organizationId()), OrganizationService.organizationsById),
      map(([, orgId, orgsById]) => orgsById[orgId]),
      filter(<T>(val: T): val is NonNullable<T> => !!val),
      distinctUntilChanged((prev, curr) => prev?.organizationId === curr?.organizationId)
    );
}
